//#region IMPORTS
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Fragment } from "react";
import { Order } from "../../models/order";
import OrderDetailPageHeaderStoreInfo from "./OrderDetailPageHeaderStoreInfo";
import GoBackButton from "../genericButtons/goBackButton/GoBackButton";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  detailgroupChecker: (value: string) => boolean;
  toggleFilter: (filterName: string) => void;
  isHQTeam: boolean;
  isPicker: boolean;
  isAdmin: boolean;
  order: Order;
}
//#endregion

export default function OrderDetailPageHeader({
  detailgroupChecker,
  toggleFilter,
  isHQTeam,
  isPicker,
  isAdmin,
  order,
}: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Router
  const history = useHistory();
  //#endregion

  //#region RENDER
  return (
    <header className="border-b-2 border-slate-900 mb-8">
      {/* Order info */}
      <div className="flex justify-between gap-4 pl-2 mb-4">
        <GoBackButton />
        {order.store && (
          <Fragment>
            <div
              className="grow hover:cursor-pointer"
              onClick={() => history.push("/orders")}
            >
              <p className="text-2xl lg:text-4xl">
                <b>{order.store.store_name}</b>
              </p>
              <p className="text-xl lg:text-3xl">{order.order_code}</p>
              <p className="text-lg lg:text-2xl">{order.store.language}</p>
            </div>

            {/* Store info */}
            <OrderDetailPageHeaderStoreInfo order={order} />
          </Fragment>
        )}
      </div>

      {/* Comment box*/}
      {order.comment !== "" &&
      order.comment !== "no comment" &&
      order.comment !== "Initial order" ? (
        <article className="orders-detail-page__header__comment-box">
          <h2>
            {t("rituals.extraComment")}: <strong>{order.comment}</strong>
          </h2>
        </article>
      ) : null}

      {/* View switcher */}
      <div className="flex flex-wrap items-center gap-3 mb-3">
        {/* By Printer */}
        {(isAdmin || isPicker || isHQTeam) && (
          <button
            type="button"
            onClick={() => toggleFilter("produced_by")}
            className={classNames(
              "inline-flex items-center rounded-md border px-3 py-1.5 text-sm font-medium shadow-sm transition",
              detailgroupChecker("produced_by")
                ? "bg-black text-white border-black hover:bg-gray-800"
                : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50",
            )}
          >
            {detailgroupChecker("produced_by")
              ? t("rituals.listView")
              : t("rituals.viewByPrinter")}
          </button>
        )}

        {/* By parcel */}
        {order && order.sub_orders.length > 1 && (
          <>
            <button
              type="button"
              onClick={() => toggleFilter("sub_order_id")}
              className={classNames(
                "inline-flex items-center rounded-md border px-3 py-1.5 text-sm font-medium shadow-sm transition",
                detailgroupChecker("sub_order_id")
                  ? "bg-black text-white border-black hover:bg-gray-800"
                  : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50",
              )}
            >
              {detailgroupChecker("sub_order_id")
                ? t("rituals.listView")
                : t("rituals.viewByParcel")}
            </button>
            {!detailgroupChecker("sub_order_id") && (
              <p className="text-sm text-gray-500">
                {t("rituals.thisOrderIncludes$VAR$Parcels").replace(
                  "$VAR$",
                  order.sub_orders.length.toString(),
                )}
              </p>
            )}
          </>
        )}
      </div>
    </header>
  );
  //#endregion
}
